import getLogoutTarget from './getLogoutTarget';

export default getLogoutTarget;
